import { ExternalUserServiceIntegration } from '../../models/User'
import { IntegrationServiceId } from '../../common/integrations'
import { IntegrationIcon } from '../../components/IntegrationIcon'

export const getConnectorIcon = (emailIntegration: ExternalUserServiceIntegration | null) => {
  if (!emailIntegration) {
    return null
  }
  const { serviceId } = emailIntegration
  if (serviceId === IntegrationServiceId.GMAIL) {
    return <IntegrationIcon serviceId={IntegrationServiceId.GMAIL} width={24} height={24} />
  }
  if (serviceId === IntegrationServiceId.OUTLOOK_MAIL) {
    return <IntegrationIcon serviceId={IntegrationServiceId.OUTLOOK_MAIL} width={24} height={24} />
  }
  return null
}
